import Vue from 'vue/dist/vue.esm';
import TurbolinksAdapter from 'vue-turbolinks';
import ItemShowContainer from '../../vue/marketplace/item_show/container.vue';

Vue.prototype.i18n = window.i18n;
Vue.use(TurbolinksAdapter);

if (window.itemComponent) {
  window.itemComponent.$destroy(true);
}

window.itemComponent = new Vue({
  el: '#item-show',
  components: { ItemShowContainer }
});
